module.exports = "<!-- $Id: alert.template.html 54447 2017-07-26 23:34:29Z eduardo.s.neto $ -->\r\n<ngb-alert *ngIf=\"messageValue != null\" [type]=\"type\" (close)=\"messageValue = null\">\r\n  <p>{{ messageValue }}</p>\r\n</ngb-alert>"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/alert.template.html
// module id = 1187
// module chunks = 1